<div class="member-continue-reactivation align-items-center heightContent100" *ngIf="isReactivationVisible()">
    <div class="text-center mx-auto">
        <h4 class="py-2">Renew your Fitness Passport membership!</h4>
        <div class="pt-3">
            <button class="px-5 py-2 btn btn-primary" (click)="ContinueReactivation()">REACTIVATE MEMBERSHIP</button>
        </div>
    </div>
</div>